import { cn } from "../utils/helpers";
import { SvgProps } from "../utils/types";

export default function PlusIcon({ className }: SvgProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            width="24"
            height="24"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={cn("shrink-0 size-3.5", className)}
        >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
    );
}
